// import { HashRouter as Router, Switch, Route } from "react-router-dom";
import Main from "./components/Main/index"

function App() {
  return (
    // <Router>
    //   <Switch>
        
    //   </Switch>
    //   </Router>
    <>
    <Main />
    </>
  );
}

export default App;
